import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { HiOutlineArrowUpTray, HiMagnifyingGlass } from "react-icons/hi2";
import { fmtDateTime } from "../../../Utils/dateFormat";

const formatDateInput = (date) => date.toISOString().split("T")[0];

const B2CConsignmentReport = () => {
  const navigate = useNavigate();
  const today = new Date();
  const twoDaysAgo = new Date();
  twoDaysAgo.setDate(today.getDate() - 2);
  const user = JSON.parse(localStorage.getItem("loginObj"));
  const [loggedInUser] = useState(
    user.userRolesList.find(
      (user) => user.roleCode === "PHHEAD" || user.roleCode === "PH"
    )
  );

  const statusLabels = [
    { label: "Fully completed", value: "FULLYCOMPLETED" },
    { label: "Not completed", value: "NOTCOMPLETED" },
    { label: "All", value: "ALL" },
    { label: "Not packed", value: "NOTPACKED" },
    { label: "Not shipped", value: "NOTSHIPPED" },
    { label: "Not order on bus", value: "NOTORDERONBUS" },
    { label: "Not out for delivery", value: "NOTOUTFORDELIVERY" },
    { label: "Not delivered", value: "NOTDELIVERED" },
  ];

  const stateList = [
    { name: "Odisha", value: "OD" },
    { name: "Chhattisgarh", value: "CG" },
    { name: "Jharkhand", value: "JH" }
  ];

  const datesrcList = [
    { name: "Enquiry Date", value: "ENQUIRY" },
    { name: "Order Date", value: "ORDER" },
    { name: "Consignment", value: "CONSIGN" },
  ];

  const [defaultWHList, setdefaultWHList] = useState([]);
  const [warehouseList, setwarehouseList] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const warehouseDropdownRef = useRef(null);
  const [filters, setFilters] = useState({
    source: "B2C",
    dateChannel: "ORDER",
    fromDate: formatDateInput(twoDaysAgo),
    toDate: formatDateInput(today),
    consignmentId: "",
    enquiryId: "",
    orderId: "",
    statusFilter: "ALL",
    page: 1,
    state:
      loggedInUser?.roleCode !== "PHHEAD"
        ? localStorage.getItem("userState")
        : "OD",
    circleCode: localStorage.getItem("circleCode") || "N",
    circleCodes: localStorage.getItem("circleCode")
      ? [localStorage.getItem("circleCode")]
      : ["N"],
  });

  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const itemsPerPage = 15;
  const indexOfLastItem = filters.page * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const formatDate = (date) => {
    const d = new Date(date);
    return `${String(d.getMonth() + 1).padStart(2, "0")}/${String(
      d.getDate()
    ).padStart(2, "0")}/${d.getFullYear()}`;
  };

  const wareHouseData = async () => {
    try {
      const response = await axios.get(`${apiUrl}warehouse/list`);
      const res = response.data.successList;
      setdefaultWHList(res);
      setwarehouseList(res.filter((e) => e.stateCode == filters.state));
    } catch (err) {
      console.error("Error fetching warehouse details:", err);
    }
  };

  useEffect(() => {
    setwarehouseList(defaultWHList.filter((e) => e.stateCode == filters.state));
  }, [filters.state]);

  useEffect(() => {
    wareHouseData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        warehouseDropdownRef.current &&
        !warehouseDropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
      page: 1,
    }));
  };

  const handleSearch = () => {
    fetchData();
  };

  const fetchData = async () => {
    setIsLoading(true);
    const url = `${apiUrl}report/consignment/b2c`;
    const params = {
      state: filters.state,
      fromDate: formatDate(filters.fromDate),
      toDate: formatDate(filters.toDate),
      dateChannel: filters.dateChannel,
      conFilter: filters.statusFilter,
    };

    if (filters.circleCodes && filters.circleCodes.length > 0) {
      params.circleCode = filters.circleCodes.join(",");
    }

    if (filters.orderId) {
      params.orderId = filters.orderId;
    }
    if (filters.consignmentId) {
      params.consignmentId = filters.consignmentId;
    }
    if (filters.enquiryId) {
      params.enquiryId = filters.enquiryId;
    }

    try {
      const response = await axios.get(url, { params });
      const list = response?.data?.successList || [];
      setTableData(list);
      setFilteredData(list);
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData()
  }, []);

  const handleSourceChange = (e) => {
    const selected = e.target.value;
    setFilters((prev) => ({ ...prev, source: selected }));

    // B2B Partners screens disabled — drop B2B redirect branch.
    // if (selected === "B2B") {
    //   navigate("/consignment/b2b");
    // } else
    if (selected === "CHE/Engage") {
      navigate("/consignment/che");
    }
  };

  const handleExport = async () => {
    let url = `${apiUrl}export/download/consignment/b2c?fromDate=${formatDate(
      filters.fromDate
    )}&toDate=${formatDate(filters.toDate)}&state=${filters.state
      }&dateChannel=${filters.dateChannel}&conFilter=${filters.statusFilter
      }&circleCode=${filters.circleCode}`;

    if (filters.orderId) {
      url += `&orderId=${filters.orderId}`;
    }
    if (filters.consignmentId) {
      url += `&consignmentId=${filters.consignmentId}`;
    }
    if (filters.enquiryId) {
      url += `&enquiryId=${filters.enquiryId}`;
    }

    try {
      const response = await axios.get(url, { responseType: "blob" });
      const blob = new Blob([response.data], {
        type: "application/vnd.ms-excel",
      });
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `ConsignmentReport_B2C_${filters.fromDate}_to_${filters.toDate}.xlsx`;
      link.click();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Export failed", error);
    }
  };

  const renderPagination = () => {
    const visiblePages = 5;
    let startPage = Math.max(1, filters.page - Math.floor(visiblePages / 2));
    let endPage = startPage + visiblePages - 1;
    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - visiblePages + 1);
    }

    const pageButtons = [];
    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <button
          key={i}
          onClick={() => setFilters((prev) => ({ ...prev, page: i }))}
          className={`w-8 h-8 text-sm border rounded-full ${filters.page === i
            ? "bg-blue-500 text-white"
            : "hover:bg-gray-200 text-gray-700"
            }`}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="flex flex-wrap items-center justify-center gap-2 mt-6 ">
        <button
          onClick={() => setFilters((prev) => ({ ...prev, page: 1 }))}
          disabled={filters.page === 1}
          className="text-lg disabled:opacity-50"
        >
          «
        </button>
        <button
          onClick={() =>
            setFilters((prev) => ({
              ...prev,
              page: Math.max(prev.page - 1, 1),
            }))
          }
          disabled={filters.page === 1}
          className="text-lg disabled:opacity-50"
        >
          ‹
        </button>
        {pageButtons}
        <button
          onClick={() =>
            setFilters((prev) => ({
              ...prev,
              page: Math.min(prev.page + 1, totalPages),
            }))
          }
          disabled={filters.page === totalPages}
          className="text-lg disabled:opacity-50"
        >
          ›
        </button>
        <button
          onClick={() => setFilters((prev) => ({ ...prev, page: totalPages }))}
          disabled={filters.page === totalPages}
          className="text-lg disabled:opacity-50"
        >
          »
        </button>
      </div>
    );
  };

  return (
    <div className="p-3 sm:p-6 bg-white rounded-lg">
      <div className="mb-4 text-sm text-gray-500">
        <span className="text-gray-700 font-medium">Reports</span> &gt;{" "}
        <span className="text-blue-600 font-semibold">
          {filters.source} Consignment Report
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-3 mb-6">
        <select
          className="border px-4 py-2 rounded w-[160px]"
          value={filters.source}
          onChange={handleSourceChange}
          name="source"
        >
          <option>B2C</option>
          {/* B2B Partners screens disabled — hide B2B source option. */}
          {/* <option>B2B</option> */}
          <option>CHE/Engage</option>
        </select>

        {loggedInUser?.roleCode === "PHHEAD" && (
          <>
            <select
              name="state"
              value={filters.state}
              onChange={handleFilterChange}
              className="border px-3 py-2 w-48 rounded-lg"
            >
              {stateList.map((s) => (
                <option key={s.value} value={s.value}>
                  {s.name}
                </option>
              ))}
            </select>
            <div className="flex items-center">
              <div className="relative w-64" ref={warehouseDropdownRef}>
                <div
                  className="flex items-center justify-between border rounded-lg px-3 py-2 cursor-pointer"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <span className="truncate">
                    {filters.circleCodes.length > 0
                      ? `${filters.circleCodes.length} warehouse(s) selected`
                      : "Select Warehouses"}
                  </span>
                  <svg
                    className={`w-4 h-4 ml-2 transition-transform ${
                      dropdownOpen ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
                {dropdownOpen && (
                  <div className="absolute z-50 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto">
                    {warehouseList.map((warehouse) => {
                      const checked = filters.circleCodes.includes(
                        warehouse.circleCode
                      );
                      return (
                        <label
                          key={warehouse.pharmacyCode}
                          className="flex items-center px-3 py-2 cursor-pointer hover:bg-gray-100"
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={(e) => {
                              let updated = [...filters.circleCodes];
                              if (e.target.checked) {
                                updated.push(warehouse.circleCode);
                              } else {
                                updated = updated.filter(
                                  (c) => c !== warehouse.circleCode
                                );
                              }
                              setFilters((prev) => ({
                                ...prev,
                                circleCodes: updated,
                              }));
                            }}
                            className="mr-2"
                          />
                          {warehouse.pharmacyName}
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
              {filters.circleCodes.length > 0 && (
                <button
                  onClick={() =>
                    setFilters((prev) => ({ ...prev, circleCodes: [] }))
                  }
                  className="text-red-500 text-sm ml-2 whitespace-nowrap"
                  style={{ marginLeft: "8px" }}
                >
                  Reset
                </button>
              )}
            </div>
          </>
        )}

        <select
          className="border px-4 py-2 rounded w-[160px]"
          value={filters.dateChannel}
          onChange={handleFilterChange}
          name="dateChannel"
        >
          {datesrcList.map((item) => (
            <option key={item.value} value={item.value}>
              {item.name}
            </option>
          ))}
        </select>

        <input
          type="date"
          className="border px-4 py-2 rounded"
          value={filters.fromDate}
          onChange={handleFilterChange}
          name="fromDate"
        />

        <input
          type="date"
          className="border px-4 py-2 rounded"
          value={filters.toDate}
          onChange={handleFilterChange}
          name="toDate"
        />

        <input
          type="text"
          className="border px-4 py-2 rounded"
          placeholder="Type Consignment ID"
          value={filters.consignmentId}
          onChange={handleFilterChange}
          name="consignmentId"
        />

        <input
          type="text"
          className="border px-4 py-2 rounded"
          placeholder="Type Enquiry ID"
          value={filters.enquiryId}
          onChange={handleFilterChange}
          name="enquiryId"
        />

        <input
          type="text"
          className="border px-4 py-2 rounded"
          placeholder="Type Order ID"
          value={filters.orderId}
          onChange={handleFilterChange}
          name="orderId"
        />

        <select
          className="border px-4 py-2 rounded w-[160px]"
          value={filters.statusFilter}
          onChange={handleFilterChange}
          name="statusFilter"
        >
          {statusLabels.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>

        <div>
          <button
            className="flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg shadow-sm transition"
            onClick={handleSearch}
            disabled={isLoading}
          >
            <HiMagnifyingGlass className="h-5 w-5" />
            <span className="text-base font-medium">Search</span>
          </button>
        </div>

        <div>
          <button
            className="flex items-center gap-2 border border-gray-300 text-gray-600 px-4 py-2 rounded-full shadow-sm hover:bg-gray-100 transition"
            onClick={handleExport}
            disabled={isLoading}
          >
            <HiOutlineArrowUpTray className="h-5 w-4 text-indigo-400" />
            <span className="text-base font-medium">Export Excel</span>
          </button>
        </div>
      </div>

      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      ) : (
        <>
          <div className="overflow-x-auto rounded-lg shadow-md">
            <table className="min-w-[1600px] border text-sm text-[#1d2f5b] text-semi">
              <thead className="bg-gray-100 text-left">
                <tr>
                  <th className="px-4 py-2 border">Consignment ID</th>
                  <th className="px-4 py-2 border">Order ID</th>
                  <th className="px-4 py-2 border">Enquiry ID</th>
                  <th className="px-4 py-2 border">Source</th>
                  <th className="px-4 py-2 border">Patient Name</th>
                  <th className="px-4 py-2 border">Address</th>
                  <th className="px-4 py-2 border">Contact No</th>
                  <th className="px-4 py-2 border">Packed Date</th>
                  <th className="px-4 py-2 border">Shipped Date</th>
                  <th className="px-4 py-2 border">Order on the Bus</th>
                  <th className="px-4 py-2 border">Out for Delivery</th>
                  <th className="px-4 py-2 border">Delivered Date</th>
                  <th className="px-4 py-2 border">
                    Acknowledgment By CB Team
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((row, index) => (
                    <tr key={index} className="even:bg-gray-50">
                      <td className="px-4 py-2 text-gray-700">
                        {row.consignmentId}
                      </td>
                      <td className="px-4 py-2 text-gray-700">{row.orderId}</td>
                      <td className="px-4 py-2 text-gray-700">
                        {row.enquiryId}
                      </td>
                      <td className="px-4 py-2 text-gray-700">
                        {row.sourceChannel}
                      </td>
                      <td className="px-4 py-2 text-gray-700">
                        {row.patientName || "-"}
                      </td>
                      <td className="px-4 py-2 text-gray-700">{row.address}</td>
                      <td className="px-4 py-2 text-gray-700">
                        {row.contactNumber}
                      </td>
                      <td className="px-4 py-2 text-gray-700">
                        {row.createdDate
                          ? fmtDateTime(row.createdDate, { zone: "utc-ist" })
                          : "-"}
                      </td>
                      <td className="px-4 py-2 text-gray-700">
                        {row.shippedDate
                          ? fmtDateTime(row.shippedDate, { zone: "utc-ist" })
                          : "-"}
                      </td>
                      <td className="px-4 py-2 text-gray-700">
                        {row.orderOnTheBus
                          ? fmtDateTime(row.orderOnTheBus, { zone: "utc-ist" })
                          : "-"}
                      </td>
                      <td className="px-4 py-2 text-gray-700">
                        {row.outForDelivery
                          ? fmtDateTime(row.outForDelivery, { zone: "utc-ist" })
                          : "-"}
                      </td>
                      <td className="px-4 py-2 text-gray-700">
                        {row.delivered
                          ? fmtDateTime(row.delivered, { zone: "utc-ist" })
                          : "-"}
                      </td>
                      <td className="px-4 py-2 text-gray-700">
                        {row.receivedByCbteam
                          ? fmtDateTime(row.receivedByCbteam, { zone: "utc-ist" })
                          : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="13"
                      className="px-4 py-6 text-center text-gray-500"
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && renderPagination()}
        </>
      )}
    </div>
  );
};

export default B2CConsignmentReport;
